import React from 'react';
import './error.css'
import Navbar from '../components/navbar/navbar';

import Footer from '../components/sections/footer';
import ErrorSection from '../components/sections/ErrorSection';

const Error = () => {
    return ( <>
    <Navbar />
    <ErrorSection />
    <Footer />
    </> );
}
 
export default Error;